package com.hyperether.goodjob.scenes.addNew

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.models.Contact
import com.hyperether.goodjob.models.Site
import com.hyperether.goodjob.models.User
import com.hyperether.goodjob.repository.Repository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import org.lighthousegames.logging.logging

class AddNewViewModel(val repository: Repository) : ViewModel() {

    val log = logging("AddNewViewModel")

    private val _users = MutableStateFlow<List<User>>(emptyList())
    val users: StateFlow<List<User>> = _users

    private val _contacts = MutableStateFlow<List<Contact>>(emptyList())
    val contacts: StateFlow<List<Contact>> = _contacts

    private val _sites = MutableStateFlow<List<Site>>(emptyList())
    val sites: StateFlow<List<Site>> = _sites

    val showPopUpSuccess: MutableState<Boolean> = mutableStateOf(false)
    val showPopUpError: MutableState<Boolean> = mutableStateOf(false)
    val showLoader: MutableState<Boolean> = mutableStateOf(false)

    init {
        if (getPlatformChecker().isMobile()) {
            log.d("getContactsFlow AddNewJobScreen") { "init isMobile: ${getPlatformChecker().isMobile()}" }
            init()
        }
    }

    fun init() {
        repository.getToken().takeIf { it.isNotEmpty() }?.let {
            viewModelScope.launch {
                repository.getTeams()
            }
        }

        viewModelScope.launch {
            repository.getContactsFlow().collect {
                _contacts.value = it
            }
        }

        viewModelScope.launch {
            repository.getUsersFlow().collect {
                _users.value = it
            }
        }

        viewModelScope.launch {
            repository.getSitesFlow().collect {
                _sites.value = it
            }
        }
    }
}